import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';

export default {
  topic: 'Meeting title',
  date: 'Date',
  startTime: 'Time',
  duration: 'Duration',
  scheduleFor: 'Schedule on behalf of',
  meetingSettings: 'Meeting settings',
  meetingSettingsDescription:
    'Update these settings will apply to current meeting only.',
  here: 'here',
  [ASSISTED_USERS_MYSELF]: 'Myself',
  joinBeforeHost: 'Allow participants to join before host',
  enableWaitingRoom: 'Enable waiting room',
  waitingRoom: 'Enable waiting room for',
  waitingRoomTitle: 'Waiting room',
  waitingRoomDescription: 'Keep meetings private until you admit participants.',
  waitingRoomNotCoworker: 'Anyone outside my company',
  waitingRoomGuest: 'Anyone not signed in',
  waitingRoomAll: 'Everyone',
  enterPassword: 'Enter Password',
  onlyJoinAfterMe: 'Participants can only join after me',
  onlyJoinAfterHost: 'Participants can only join after host',
  allowJoinBeforeHostDescription:
    'Keeps the meeting secure and distraction-free until you join.',
  muteAudio: 'Mute audio for participants',
  turnOffCamera: 'Turn off camera for participants',
  requirePassword: 'Require password',
  useE2ee: 'Use end-to-end encryption',
  e2eeTooltip:
    "End-to-end encrypted meetings are the most private, but features like joining by phone, closed captions, and recording aren't available.",
  setPassword: 'Set password *',
  setPasswordNotSymbol: 'Set password',
  passwordEmptyError: 'Meeting password required',
  passwordInvalidError:
    'Your password must be 1-10 letters and numbers long but cannot contain symbols',
  passwordHintText:
    'Your password should be 1-10 letters and numbers long but cannot contain symbols',
  usePersonalMeetingId: 'Use Personal Meeting ID',
  usePersonalMeetingIdInstead: 'Use personal meeting instead',
  usePersonalMeetingName: 'Use personal meeting:',
  meetingSettingsSecurity: 'Security',
  onlyAuthUserJoin: 'Only authenticated users can join',
  signedInUsers: 'Signed in users',
  signedInCoWorkers: 'Signed in co-workers',
  limitScreenSharing: 'Only host & moderators can share screen',
  lockTooltip: 'This setting is managed by your company admin',
  pmiSettingAlert: 'These settings will apply to all meetings created with PMI',
  today: 'Today',
  scheduleForGuidance:
    "Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n",
  scheduleForGuidanceMore: 'Learn details',
  changePmiSettings: 'Change Personal Meeting settings',
  allowToRecording: 'Allow to start and stop recording',
  allowTranscribe: 'Allow to start and stop transcription',
  everyone: 'Everyone',
  onlyHostModerators: 'Only host and moderators',
  advancedSettings: 'Advanced settings',
  whoCanJoin: 'Who can join?',
  requirePasswordDescription:
    'Participants who join via the meeting link won’t need to enter the password.',
  password: 'Password:',
  passwordLabel: 'Password',
  edit: 'Edit',
  changePassword: 'Change Password',
  passwordRequired: 'Password is required',
  passwordLengthError: 'Password must be 1-10 characters long',
  passwordFormatError: 'Password can only contain letters and numbers',
  passwordHint:
    'Your password should be 1-10 letters and numbers long, but can not contain symbols.',
} as const;
